/**
 * Implicit ("shadow") materials are stored with a UUID for a title, so it is
 * never showable — every surface substitutes a name derived from the submittal
 * the material was created for.
 */
export function getImplicitMaterialDisplayTitle(
  parentAutoIncValue?: string | number | null
): string {
  return `Material for Submittal ${parentAutoIncValue ?? ""}`.trimEnd();
}
